import axios from "axios";
const auth = localStorage.getItem("auth_token");

export const headers = {
  "x-auth-token": auth,
};

export const getOneBookClosure = async (id, data) => {
  return axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosure/get?id=${id}`,
    data,
    { headers }
  );
};
export const createBookClosure = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosure/create`,
    data,
    { headers }
  );
};
export const addCompany = async (id, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosure/addCompany?id=${id}`,
    data,
    { headers }
  );
};
export const deleteBookClosure = async (id) => {
  return await axios.delete(
    `${process.env.REACT_APP_FSCP_URL}bookClosure/delete?id=${id}`,
    { headers }
  );
};

export const getBookClosureByCompanyIds = async (companyIds) => {
  return await axios.get(
    `api/v1/workspace/get-book-closure-company?companyIds=${companyIds}`,
    { headers }
  );
};
export const getApproverUserOptions = async (companyId) => {
  return await axios.get(
    `api/v1/workspace/get-book-closure-user?companyId=${companyId}`,
    { headers }
  );
};

export const addTask = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/add`,
    data,
    { headers }
  );
};
export const updateTask = async (taskId, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/update?id=${taskId}`,
    data,
    { headers }
  );
};
export const getOneTask = async (taskId) => {
  return axios.get(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/get?id=${taskId}`,
    { headers }
  );
};
// export const deleteTask = async (taskId) => {
//     return await axios.delete(`${process.env.REACT_APP_FSCP_URL}bookClosure/delete?id=${taskId}`, { headers });
// }

export const getLibraryList = async (bookClosureId, companyID) => {
  return axios.get(
    `${process.env.REACT_APP_FSCP_URL}bookClosureLibrary/get?id=${bookClosureId}&companyID=${companyID}`,
    { headers }
  );
};
export const importTasksFromLibrary = async (bookClosureId, data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/import?id=${bookClosureId}`,
    data,
    { headers }
  );
};
export const addTaskInLibrary = async (bookClosureId, data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosureLibrary/add`,
    data,
    { headers }
  );
};
export const updateTaskInLibrary = async (taskId, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureLibrary/update?id=${taskId}`,
    data,
    { headers }
  );
};
export const deleteTaskInLibrary = async (taskId) => {
  return await axios.delete(
    `${process.env.REACT_APP_FSCP_URL}bookClosureLibrary/delete?id=${taskId}`,
    { headers }
  );
};

// ? Submit task, when the preparer wants to submit an "open" or "returned" task.
export const submitTask = async (taskId, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/submit?id=${taskId}`,
    data,
    { headers }
  );
};
// ? Save and submit task, when the preparer wants to save and submit a new task.
export const saveAndSubmitTask = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/saveAndSubmit`,
    data,
    { headers }
  );
};
// ? Approve task, when approver wants to approve "submitted" task.
export const approveTask = async (taskId, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/approve?id=${taskId}`,
    data,
    { headers }
  );
};
// ? Return task, when approver wants to return "submitted" task.
export const returnTask = async (taskId, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/return?id=${taskId}`,
    data,
    { headers }
  );
};
export const uploadTB = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTB/upload`,
    data,
    { headers }
  );
};
export const getTbHeaders = async (bookClosureTbId) => {
  return await axios.get(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTB/getTBHeaders?id=${bookClosureTbId}`,
    { headers }
  );
};
export const setTbHeaders = async (bookClosureTbId, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTB/setTBHeaders?id=${bookClosureTbId}`,
    data,
    { headers }
  );
};
export const getTbRows = async (bookClosureTbId) => {
  return await axios.get(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTB/getTBRows?id=${bookClosureTbId}`,
    { headers }
  );
};
export const getTbDetails = async (bookClosureTbId) => {
  return await axios.get(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTB/getTBDetails?id=${bookClosureTbId}`,
    { headers }
  );
};
export const addTBNote = async (bookClosureTbId, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTB/addNote?id=${bookClosureTbId}`,
    data,
    { headers }
  );
};
export const softDeleteLedger = async (bookClosureTbId, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTB/deleteLedger?id=${bookClosureTbId}`,
    data,
    { headers }
  );
};
export const restoreLedger = async (bookClosureTbId, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTB/restoreLedger?id=${bookClosureTbId}`,
    data,
    { headers }
  );
};
export const mapLedger = async (bookClosureTbId, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTB/mapLedger?id=${bookClosureTbId}`,
    data,
    { headers }
  );
};
export const getDeletedLedgers = async (bookClosureTbId) => {
  return await axios.get(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTB/getDeletedLedgers?id=${bookClosureTbId}`,
    { headers }
  );
};

export const addLedgerToTask = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/addLedgerToTask`,
    data,
    { headers }
  );
};
export const updateLedgerInTask = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/updateLedgerIntask`,
    data,
    { headers }
  );
};
export const AddAdjustmentToTask = async (taskId, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/addAdjustmentToTask?id=${taskId}`,
    data,
    { headers }
  );
};
export const updateAdjustmentToTask = async (taskId, adjustmentID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/updateAdjustmentInTask?id=${taskId}&adjustmentID=${adjustmentID}`,
    data,
    { headers }
  );
};
export const deleteAdjustmentToTask = async (taskId, adjustmentID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/deleteAdjustmentFromTask?id=${taskId}&adjustmentID=${adjustmentID}`,
    data,
    { headers }
  );
};

export const getEntries = async (bookClosureId, companyId) => {
  return await axios.get(
    `${process.env.REACT_APP_FSCP_URL}bookClosure/getEntries?id=${bookClosureId}&companyID=${companyId}`,
    { headers }
  );
};
export const getEntriesNew = async (bookClosureId, companyId, format) => {
  const baseUrl = `${process.env.REACT_APP_FSCP_URL}bookClosure/getEntriesNew?id=${bookClosureId}&companyID=${companyId}`;
  const url = format ? `${baseUrl}&format=${format}` : baseUrl;

  return await axios.get(url, { headers });
};

export const getEntriesExport = async (bookClosureId, companyId, format) => {
  const url = `${process.env.REACT_APP_FSCP_URL}bookClosure/getEntriesNew?id=${bookClosureId}&companyID=${companyId}&format=excel`;

  return await axios.get(url, {
    headers: {
      "x-auth-token": auth,
    },
    responseType: "blob",
  });
};

export const getMatrix = async (bookClosureId, companyId) => {
  return await axios.get(
    `${process.env.REACT_APP_FSCP_URL}bookClosure/getMatrix?id=${bookClosureId}&companyID=${companyId}`,
    { headers }
  );
};

export const addCommentToTask = async (taskId, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/addCommentToTask?id=${taskId}`,
    data,
    { headers }
  );
};
export const deleteCommentInTask = async (taskId, commentID) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/deleteCommentFromTask?id=${taskId}&commentID=${commentID}`,
    { headers }
  );
};
// ! Presets
export const getAllPreset = async (page,workspaceId) => {
    return await axios.get(`${process.env.REACT_APP_FSCP_URL}bookClosurePreset/all?page=${page}&limit=${20}&sortBy=createdAt&sort=-1&workspaceId=${workspaceId}`, { headers })
}
export const savePreset = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosurePreset/save`,
    data,
    { headers }
  );
};
export const importTaskFormPreset = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosurePreset/import`,
    data,
    { headers }
  );
};

export const createCOA = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosureCOA/create`,
    data,
    { headers }
  );
};

export const getAllCOA = async (companyID) => {
  return await axios.get(
    `${process.env.REACT_APP_FSCP_URL}bookClosureCOA/all?companyID=${companyID}`,
    { headers }
  );
};

export const linkToFinacial = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosure/linkToFS`,
    data,
    { headers }
  );
};

export const addAssetsReconcillations = async (taskId, data) => {
  return axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/addROUAssetReconcillationToTask?id=${taskId}`,
    data,
    { headers }
  );
};

export const updateAssetsReconcillations = async (
  taskId,
  ROUAssetReconcillationID,
  data
) => {
  return axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/updateROUAssetReconcillationInTask?id=${taskId}&ROUAssetReconcillationID=${ROUAssetReconcillationID}`,
    data,
    { headers }
  );
};

export const deleteAssetsReconcillations = async (
  taskId,
  ROUAssetReconcillationID
) => {
  return axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/deleteROUAssetReconcillationFromTask?id=${taskId}&ROUAssetReconcillationID=${ROUAssetReconcillationID}`,
    {},
    { headers }
  );
};

export const getERPPullRequests = async (params) => {
  // return await axios.get(`${process.env.REACT_APP_ERP_URL}api/v1/erp/get-erprequests`,{params:params,headers:headers})
  return await axios.get(
    `${process.env.REACT_APP_WEB_URL}api/v1/erp/get-erprequests`,
    { params: params, headers: headers }
  );
};

export const pullERPdata = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTB/pullERPdata`,
    data,
    { headers }
  );
};

export const mapCOAtoTBApiHandler = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTB/mapCoaToTrialBalance`,
    data,
    { headers }
  );
};

export const createTBpushPackage = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTB/createTBpushPackage`,
    data,
    { headers }
  );
};

export const getAllCommentsApiHandler = async (data, sortby = 1) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/getComments?sortby=${sortby}`,
    data,
    { headers }
  );
};

export const addBookClosureColumnsApiHandler = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosureCustom/add-column`,
    data,
    { headers }
  );
};

export const getBookClosureColumnsApiHandler = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosureCustom/get-columns`,
    data,
    { headers }
  );
};

export const getBookClosureAddColumnDataApiHandler = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosureCustom/add-column-data`,
    data,
    { headers }
  );
};

export const getBookClosureDeleteColumnApiHandler = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureCustom/delete-column`,
    data,
    { headers }
  );
};

export const getBookClosureUpdateColumnApiHandler = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureCustom/update-column`,
    data,
    { headers }
  );
};

export const addCommentApiHandler = async (taskId, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/addCommentToTask?id=${taskId}`,
    data,
    { headers }
  );
};

export const editCommentApiHandler = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/updateComment`,
    data,
    { headers }
  );
};

export const postReplyApiHandler = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/replyToComment`,
    data,
    { headers }
  );
};

export const deleteCommentApiHandler = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/deleteComment`,
    data,
    { headers }
  );
};

export const updateCommentApiHandler = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/updateComment`,
    data,
    { headers }
  );
};

// export const getStaging = async (companyID) => {
//     return await axios.get(`${process.env.REACT_APP_FSCP_URL}companyPolicy/getStaging?companyID=${companyID}`, { headers })
// }

export const getAllStaging = async (companyID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/getAllStage?companyID=${companyID}`,
    { headers }
  );
};

export const createNewStaging = async (companyID, data) => {
  return await axios.post(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/addStage?companyID=${companyID}`,
    data,
    { headers }
  );
};

export const updateStaging = async (companyID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/updateStage?companyID=${companyID}`,
    data,
    { headers }
  );
};

export const deleteStaging = async (companyID, stageID) => {
  return await axios.delete(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/deleteStage?companyID=${companyID}&stageID=${stageID}`,
    { headers }
  );
};

export const getAllCategory = async (companyID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/getAllCategory?companyID=${companyID}`,
    { headers }
  );
};

export const createNewCategory = async (companyID, data) => {
  return await axios.post(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/addCategory?companyID=${companyID}`,
    data,
    { headers }
  );
};

export const updateCategory = async (companyID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/updateCategory?companyID=${companyID}`,
    data,
    { headers }
  );
};

export const deleteCategory = async (companyID, categoryID) => {
  return await axios.delete(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/deleteCategory?companyID=${companyID}&categoryID=${categoryID}`,
    { headers }
  );
};

export const getAllCategoryCombinations = async (companyID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/getAllCategoryCombinations?companyID=${companyID}`,
    { headers }
  );
};

export const getAllLoanECLScenario = async (companyID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/getAllLoanECLScenario?companyID=${companyID}`,
    { headers }
  );
};

export const getAllLoanEIRScenario = async (companyID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/getAllLoanEIRScenario?companyID=${companyID}`,
    { headers }
  );
};

export const createNewEclScenario = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/addLoanECLScenario`,
    data,
    { headers }
  );
};

export const getOneLoanECLScenario = async (scenarioID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/getOneLoanECLScenario?scenarioID=${scenarioID}`,
    { headers }
  );
};

export const updateLoanECLScenario = async (scenarioID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/updateLoanECLScenario?scenarioID=${scenarioID}`,
    data,
    { headers }
  );
};

export const deleteLoanECLScenario = async (scenarioID) => {
  return await axios.delete(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/deleteLoanECLScenario?scenarioID=${scenarioID}`,
    { headers }
  );
};

export const selectLoanECLScenario = async (loanID, loanECLScenarioID) => {
  return await axios.put(
    `${process.env.REACT_APP_LOANS_URL}loan/selectLoanECLScenario?loanID=${loanID}&loanECLScenarioID=${loanECLScenarioID}`,
    {},
    { headers }
  );
};

export const getLoanMapping = async (loanID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}loan/mapping?id=${loanID}`,
    { headers }
  );
};

export const setEclFields = async (loanID, data) => {
  return await axios.put(
    `${process.env.REACT_APP_LOANS_URL}loan/setLoanECLFields?loanID=${loanID}`,
    data,
    { headers }
  );
};

export const confirmPDData = async (loanID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}loan/confirmPDData?loanID=${loanID}`,
    { headers }
  );
};

export const confirmLGDData = async (loanID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}loan/confirmPDData?loanID=${loanID}`,
    { headers }
  );
};

export const confirmFLFData = async (loanID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}loan/confirmPDData?loanID=${loanID}`,
    { headers }
  );
};

export const calculateECL = async (loanID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}loan/calculateECL?loanID=${loanID}`,
    { headers }
  );
};

export const viewWorking = async (loanID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}loan/viewWorking?loanID=${loanID}`,
    { headers }
  );
};

export const addToLoanListing = async (loanID, dataType) => {
  return await axios.put(
    `${process.env.REACT_APP_LOANS_URL}loan/addToLoanListing?loanID=${loanID}&dataType=${dataType}`,
    {},
    { headers }
  );
};

export const getLoansData = async (loanID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}loan/get?id=${loanID}`,
    { headers }
  );
};

export const addLoanEIRScenario = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/addLoanEIRScenario`,
    data,
    { headers }
  );
};

export const updateLoanEIRScenario = async (scenarioID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/updateLoanEIRScenario?scenarioID=${scenarioID}`,
    data,
    { headers }
  );
};

export const deleteLoanEIRScenario = async (scenarioID) => {
  return await axios.delete(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/deleteLoanEIRScenario?scenarioID=${scenarioID}`,
    { headers }
  );
};

export const selectLoanEIRScenario = async (loanID, loanECLScenarioID) => {
  return await axios.put(
    `${process.env.REACT_APP_LOANS_URL}loan/selectLoanEIRScenario?loanID=${loanID}&loanEIRScenarioID=${loanECLScenarioID}`,
    {},
    { headers }
  );
};

export const setLoanEIRFields = async (loanID, data) => {
  return await axios.put(
    `${process.env.REACT_APP_LOANS_URL}loan/setLoanEIRFields?loanID=${loanID}`,
    data,
    { headers }
  );
};

export const calculateEIR = async (loanID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}loan/calculateEIR?loanID=${loanID}`,
    { headers }
  );
};

export const loansListing = async (loanID, filterLoanData = {}) => {
  return await axios.post(
    `${process.env.REACT_APP_LOANS_URL}loan/getLoanListingNew?loanID=${loanID}&page=1&pageSize=20`,
    filterLoanData,
    { headers }
  );
};

export const getAllLoanIRACScenario = async (companyID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/getAllLoanIRACScenario?companyID=${companyID}`,
    { headers }
  );
};

export const addLoanIRACScenario = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/addLoanIRACScenario`,
    data,
    { headers }
  );
};

export const updateLoanIRACScenario = async (scenarioID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/updateLoanIRACScenario?scenarioID=${scenarioID}`,
    data,
    { headers }
  );
};

export const deleteLoanIRACScenario = async (scenarioID) => {
  return await axios.delete(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/deleteLoanIRACScenario?scenarioID=${scenarioID}`,
    { headers }
  );
};

// Irac loan
export const selectLoanIRACScenario = async (loanID, loanIRACScenarioID) => {
  return await axios.put(
    `${process.env.REACT_APP_LOANS_URL}loan/selectLoanIRACScenario?loanID=${loanID}&loanIRACScenarioID=${loanIRACScenarioID}`,
    {},
    { headers }
  );
};

export const updateIRAC = async (loanID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_LOANS_URL}loan/updateIRAC?loanID=${loanID}`,
    data,
    { headers }
  );
};

export const uploadIRAC = async (loanID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_LOANS_URL}loan/uploadIRAC?loanID=${loanID}`,
    data,
    { headers }
  );
};

export const getIRACLoanList = async (loanID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}loan/getIRACLoanList?loanID=${loanID}`,
    { headers }
  );
};

export const IRACOverride = async (loanID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_LOANS_URL}loan/IRACOverride?loanID=${loanID}`,
    data,
    { headers }
  );
};

export const calculateIRAC = async (loanID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}loan/calculateIRAC?loanID=${loanID}`,
    { headers }
  );
};

// Staging DeDupe
export const uploadStage = async (loanID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_LOANS_URL}loan/uploadStage?loanID=${loanID}`,
    data,
    { headers }
  );
};

export const updateStage = async (loanID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_LOANS_URL}loan/updateStage?loanID=${loanID}`,
    data,
    { headers }
  );
};

export const getStageLoanList = async (loanID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}loan/getStageLoanList?loanID=${loanID}`,
    { headers }
  );
};

export const stageOverride = async (loanID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_LOANS_URL}loan/stageOverride?loanID=${loanID}`,
    data,
    { headers }
  );
};

export const calculateStage = async (loanID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}loan/calculateStage?loanID=${loanID}`,
    { headers }
  );
};

// Loans Listing
export const UploadLoanFiles = async (loanID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_LOANS_URL}loan/files?id=${loanID}`,
    data,
    { headers }
  );
};

export const GetLoanMapping = async (loanID, data) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}loan/mapping?id=${loanID}`,
    { headers }
  );
};

export const saveLoanMapping = async (loanID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_LOANS_URL}loan/mapping?id=${loanID}`,
    data,
    { headers }
  );
};

export const GetSubLoanMapping = async (loanID, classificationType) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}loan/submapping?id=${loanID}&classification=${classificationType}`,
    { headers }
  );
};

export const submapping = async (loanID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_LOANS_URL}loan/submapping?id=${loanID}`,
    data,
    { headers }
  );
};

export const syncERPData = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTB/syncERPData`,
    data,
    { headers }
  );
};

export const getRegistersDataApiHandler = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/getRegistersData`,
    data,
    { headers }
  );
};

export const getAllLeaseDataApiHandler = async (params, data) => {
  return await axios.post(
    `${process.env.REACT_APP_LEASE_URL}lease/getAllLeaseData`,
    data,
    { params: params, headers: headers }
  );
};

export const updateTemplateTaskLedgersApiHandler = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/updateTemplateTaskLedgers`,
    data,
    { headers: headers }
  );
};

export const updateConnectedTaskReviewApiHandler = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/updateConnectedTaskReview`,
    data,
    { headers: headers }
  );
};

export const reopenBookClosureTaskApiHandler = async (params) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/reOpen`,
    {},
    { params: params, headers: headers }
  );
};

// Receivables Lisiting

export const receivablesListing = async (
  receviablesID,
  filterLoanData = {},
  page = 1,
  pageSize = 20
) => {
  return await axios.post(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/getReceivableListing?receivableID=${receviablesID}&page=${page}&pageSize=${pageSize}`,
    filterLoanData,
    { headers }
  );
};

export const receivablesUploadFiles = async (receviablesID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/files?id=${receviablesID}`,
    data,
    { headers }
  );
};

export const GetReceivableMapping = async (receviablesID) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/mapping?id=${receviablesID}`,
    { headers }
  );
};

export const saveReceivableMapping = async (receviablesID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/mapping?id=${receviablesID}`,
    data,
    { headers }
  );
};

export const getAllReceivableMappings = async (companyID) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/getAllReceivableMapping?companyID=${companyID}&sortBy=createdAt&sort=-1`,
    { headers }
  );
};

export const saveReceivableMappingName = async (companyID, name, mapping) => {
  return axios.post(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/saveReceivableMapping?companyID=${companyID}&name=${encodeURIComponent(name)}`,
    mapping,
    { headers }
  );
};



export const GetSubReceivableMapping = async (receviablesID, type) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/submapping?id=${receviablesID}&type=${type}`,
    { headers }
  );
};

export const subReceivablemapping = async (receviablesID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/submapping?id=${receviablesID}`,
    data,
    { headers }
  );
};

// RECEIVABLES ECL

export const getReceivablesData = async (receviablesID) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/get?id=${receviablesID}`,
    { headers }
  );
};

export const getReceivableExclusionOptions = async (
  receivableID,
  exclusionField
) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/getReceivableExclusionOptions`,
    {
      params: {
        receivableID,
        exclusionField,
      },
      headers,
    }
  );
};



export const selectReceivableECLScenario = async (
  receviablesID,
  receviablesECLID
) => {
  return await axios.put(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/selectReceivableECLScenario?receivableID=${receviablesID}&receivableECLScenarioID=${receviablesECLID}`,
    {},
    { headers }
  );
};

export const getreceviablesMapping = async (receviablesID) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/mapping?id=${receviablesID}`,
    { headers }
  );
};

export const setReceviablesEclFields = async (receviablesID, data) => {
  return await axios.put(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/setReceivableECLFields?receivableID=${receviablesID}`,
    data,
    { headers }
  );
};

export const recevibalesUserConfirmation = async (receviablesID) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/confirmPDData?receivableID=${receviablesID}`,
    { headers }
  );
};

export const calculateReceviablesECL = async (receviablesID) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/calculateECL?receivableID=${receviablesID}`,
    { headers }
  );
};

export const getReceivableECLEntries = async (receivableID) => {
  return axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/getECLEntry?receivableID=${receivableID}`,
    { headers }
  );
};

export const saveReceivableECLEntries = async (receivableID, data) => {
  return axios.post(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/saveECLEntry?receivableID=${receivableID}`,
    data,
    { headers }
  );
};

export const exportReceivableWorkings = (receivableID) => {
  return axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/exportReceivableWorkings?receivableID=${receivableID}`, { 
      responseType: 'blob' ,
      headers
  });
};

export const receivableViewWorking = async (receviablesID) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/viewWorking?receivableID=${receviablesID}`,
    { headers }
  );
};

export const addToReceivablesListing = async (receviablesID, dataType) => {
  return await axios.put(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/addToReceivableListing?receivableID=${receviablesID}&dataType=${dataType}`,
    {},
    { headers }
  );
};

export const getAllReceivablesErpData = async (receviablesID) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/getAllERPReceivables?receivableID=${receviablesID}`,
    { headers }
  );
};

export const putReceivableFromERP = async (receviablesID, ERPReceivableID) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/pullReceivableFromERP?receivableID=${receviablesID}&ERPReceivableID=${ERPReceivableID}`,
    { headers }
  );
};

// receivable category

export const getAllCategoryReceivable = async (companyID) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}companyPolicy/getAllCategory?companyID=${companyID}`,
    { headers }
  );
};

export const createNewCategoryReceivable = async (companyID, data) => {
  return await axios.post(
    `${process.env.REACT_APP_RECEIVABLES_URL}companyPolicy/addCategory?companyID=${companyID}`,
    data,
    { headers }
  );
};

export const updateCategoryReceivable = async (companyID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_RECEIVABLES_URL}companyPolicy/updateCategory?companyID=${companyID}`,
    data,
    { headers }
  );
};

export const deleteCategoryReceivable = async (companyID, categoryID) => {
  return await axios.delete(
    `${process.env.REACT_APP_RECEIVABLES_URL}companyPolicy/deleteCategory?companyID=${companyID}&categoryID=${categoryID}`,
    { headers }
  );
};

// Accounting Policy Receivables

export const getAllReceivableECLScenario = async (companyID) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}companyPolicy/getAllReceivableECLScenario?companyID=${companyID}`,
    { headers }
  );
};

export const getAllCategoryCombinationsReceivables = async (companyID) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}companyPolicy/getAllCategoryCombinations?companyID=${companyID}`,
    { headers }
  );
};

export const createNewEclScenarioReceivable = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_RECEIVABLES_URL}companyPolicy/addReceivableECLScenario`,
    data,
    { headers }
  );
};

export const getOneReceivableECLScenario = async (scenarioID) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}companyPolicy/getOneReceivableECLScenario?scenarioID=${scenarioID}`,
    { headers }
  );
};

export const updateReceivablesECLScenario = async (scenarioID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_RECEIVABLES_URL}companyPolicy/updateReceivableECLScenario?scenarioID=${scenarioID}`,
    data,
    { headers }
  );
};

export const deleteReceivableECLScenario = async (scenarioID) => {
  return await axios.delete(
    `${process.env.REACT_APP_RECEIVABLES_URL}companyPolicy/deleteReceivableECLScenario?scenarioID=${scenarioID}`,
    { headers }
  );
};

// Data Bases
export const getAllCompanyRegisterDatabase = async (companyID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/getAllCompanyRegisterDatabase?companyID=${companyID}&type=loan`,
    { headers }
  );
};

export const companyLoans = async (companyID) => {
  return await axios.get(
    `${process.env.REACT_APP_LOANS_URL}loan/all?sortBy=createdAt&sort=-1&companyID=${companyID}`,
    { headers }
  );
};

export const addToCompanyRegisterDatabase = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/addToCompanyRegisterDatabase`,
    data,
    { headers }
  );
};

export const updateCompanyRegisterDatabase = async (databaseID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/updateCompanyRegisterDatabase?databaseID=${databaseID}`,
    data,
    { headers }
  );
};

export const deleteCompanyRegisterDatabase = async (databaseID) => {
  return await axios.delete(
    `${process.env.REACT_APP_LOANS_URL}companyPolicy/deleteCompanyRegisterDatabase?databaseID=${databaseID}`,
    { headers }
  );
};

export const getAllCompanyRegisterDatabaseReceivable = async (companyID) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}companyPolicy/getAllCompanyRegisterDatabase?companyID=${companyID}&type=receivable`,
    { headers }
  );
};

export const getAllCompanyReceivables = async (companyID) => {
  return await axios.get(
    `${process.env.REACT_APP_RECEIVABLES_URL}receivable/all?sortBy=createdAt&sort=-1&companyID=${companyID}`,
    { headers }
  );
};

export const addToCompanyRegisterDatabaseRecev = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_RECEIVABLES_URL}companyPolicy/addToCompanyRegisterDatabase`,
    data,
    { headers }
  );
};

export const updateCompanyRegisterDatabaseRecev = async (databaseID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_RECEIVABLES_URL}companyPolicy/updateCompanyRegisterDatabase?databaseID=${databaseID}`,
    data,
    { headers }
  );
};

export const deleteCompanyRegisterDatabaseRecev = async (databaseID) => {
  return await axios.delete(
    `${process.env.REACT_APP_RECEIVABLES_URL}companyPolicy/deleteCompanyRegisterDatabase?databaseID=${databaseID}`,
    { headers }
  );
};

// export const createNewStaging = async (companyID,data) => {
//     return await axios.patch(`${process.env.REACT_APP_FSCP_URL}companyPolicy/addStaging?companyID=${companyID}`, data, { headers })
// }

// export const createNewCategory = async (companyID,data) => {
//     return await axios.patch(`${process.env.REACT_APP_FSCP_URL}companyPolicy/updateCategory?companyID=${companyID}`, data, { headers })
// }

// Overview

export const getBookClosureOverview = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}bookClosure/getOverview`,
    data,
    { headers }
  );
};

export const getBookClosureupdateOverviewFilters = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}workspaceOverview/updateOverviewFilters`,
    data,
    { headers }
  );
};
export const getUpdateOverviewCards = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}workspaceOverview/updateOverviewCards`,
    data,
    { headers }
  );
};

export const getCopyWorkspaceViewToPrivate = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_FSCP_URL}workspaceOverview/copyWorkspaceViewToPrivate`,
    data,
    { headers }
  );
};

export const updateTaskAttachments = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/taskAttachments`,
    data,
    { headers }
  );
};

export const deleteTask = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/deleteTask`,
    data,
    { headers }
  );
};

export const restoreTasks = async (data) => {
  return await axios.patch(
    `${process.env.REACT_APP_FSCP_URL}bookClosureTask/restoreTasks`,
    data,
    { headers }
  );
};

//payable_register

export const uploadPayableFile = async (PayableID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_PAYABLE_URL}payable/files?id=${PayableID}`,
    data,
    { headers }
  );
};

export const getPayableMapping = async (PayableID) => {
  return await axios.get(
    `${process.env.REACT_APP_PAYABLE_URL}payable/mapping?id=${PayableID}`,
    { headers }
  );
};

export const updatePayableMapping = async (PayableID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_PAYABLE_URL}payable/mapping?id=${PayableID}`,
    data,
    { headers }
  );
};

export const getPayableMappingCategory = async (PayableID) => {
  return await axios.get(
    `${process.env.REACT_APP_PAYABLE_URL}payable/submapping?id=${PayableID}&type=category`,
    { headers }
  );
};

export const getPayableMappingCurrency = async (PayableID) => {
  return await axios.get(
    `${process.env.REACT_APP_PAYABLE_URL}payable/submapping?id=${PayableID}&type=foreignCurrency`,
    { headers }
  );
};

export const updatePayableSubmapping = async (PayableID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_PAYABLE_URL}payable/submapping?id=${PayableID}`,
    data,
    { headers }
  );
};

export const getPayableListing = async (PayableID, { page, pageSize, filters }) => {
  return await axios.post(
    `${process.env.REACT_APP_PAYABLE_URL}payable/getPayableListing?payableID=${PayableID}&page=${page}&pageSize=${pageSize}`,
    { filters },
    { headers: headers }
  );
};

export const getPayable = async (PayableID) => {
  return await axios.post(
    `${process.env.REACT_APP_PAYABLE_URL}payable/all?sortBy=createdAt&sort=-1&companyID=${PayableID}`
  );
};

//Sales Register

export const uploadSalesRegisterFile = async (SaleID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_PAYABLE_URL}sale/files?id=${SaleID}`,
    data,
    { headers }
  );
};

export const getSaleMapping = async (SaleID) => {
  return await axios.get(
    `${process.env.REACT_APP_PAYABLE_URL}sale/mapping?id=${SaleID}`,
    { headers }
  );
};

export const updateSaleMapping = async (SaleID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_PAYABLE_URL}sale/mapping?id=${SaleID}`,
    data,
    { headers }
  );
};

export const getSaleSubmappingCategory = async (SaleID) => {
  return await axios.get(
    `${process.env.REACT_APP_PAYABLE_URL}sale/submapping?id=${SaleID}&type=category`,
    { headers }
  );
};

export const getSaleSubmappingCurrency = async (SaleID) => {
  return await axios.get(
    `${process.env.REACT_APP_PAYABLE_URL}sale/submapping?id=${SaleID}`,
    { headers }
  );
};

export const patchSaleSubmapping = async (SaleID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_PAYABLE_URL}sale/submapping?id=${SaleID}`,
    data,
    { headers }
  );
};

export const salesListing = async (SaleID, { page, pageSize, filters }) => {
  return await axios.post(
    `${process.env.REACT_APP_PAYABLE_URL}sale/getSaleListing?saleID=${SaleID}&page=${page}&pageSize=${pageSize}`,
    { filters },
    { headers: headers }
  );
};

//purchase_register

export const uploadPurchaseRegisterFile = async (PurchaseID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_PAYABLE_URL}purchase/files?id=${PurchaseID}`,
    data,
    { headers }
  );
};

export const getPurchaseMapping = async (PurchaseID) => {
  return await axios.get(
    `${process.env.REACT_APP_PAYABLE_URL}purchase/mapping?id=${PurchaseID}`,
    { headers }
  );
};

export const updatePurchaseMapping = async (PurchaseID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_PAYABLE_URL}purchase/mapping?id=${PurchaseID}`,
    data,
    { headers }
  );
};

export const getPurchaseSubmappingCategory = async (PurchaseID) => {
  return await axios.get(
    `${process.env.REACT_APP_PAYABLE_URL}purchase/submapping?id=${PurchaseID}&type=category`,
    { headers }
  );
};

export const getPurchaseSubmappingCurrency = async (PurchaseID) => {
  return await axios.get(
    `${process.env.REACT_APP_PAYABLE_URL}purchase/submapping?id=${PurchaseID}`,
    { headers }
  );
};

export const updatePurchaseSubmapping = async (PurchaseID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_PAYABLE_URL}purchase/submapping?id=${PurchaseID}`,
    data,
    { headers }
  );
};

export const purchaseListing = async (PurchaseID,{ page, pageSize, filters }) => {
  return await axios.post(
    `${process.env.REACT_APP_PAYABLE_URL}purchase/getPurchaseListing?purchaseID=${PurchaseID}&page=${page}&pageSize=${pageSize}`,
    { filters },
    { headers: headers }
  );
};

//fixed_assets_register

export const uploadFAFile = async (FixedAssetID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_PAYABLE_URL}fixedAsset/files?id=${FixedAssetID}`,
    data,
    { headers }
  );
};

export const getFixedAssetMapping = async (FixedAssetID) => {
  return await axios.get(
    `${process.env.REACT_APP_PAYABLE_URL}fixedAsset/mapping?id=${FixedAssetID}`,
    { headers }
  );
};

export const updateFixedAssetMapping = async (FixedAssetID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_PAYABLE_URL}fixedAsset/mapping?id=${FixedAssetID}`,
    data,
    { headers }
  );
};

export const getFixedAssetSubmappingCategory = async (FixedAssetID) => {
  return await axios.get(
    `${process.env.REACT_APP_PAYABLE_URL}fixedAsset/submapping?id=${FixedAssetID}`,
    { headers }
  );
};

export const getFixedAssetSubmappingCurrency = async (FixedAssetID) => {
   return await axios.get(
    `${process.env.REACT_APP_PAYABLE_URL}fixedAsset/submapping?id=${FixedAssetID}`,
     { headers }
  );
};

export const updateFixedAssetSubMapping = async (FixedAssetID, data) => {
  return await axios.patch(
    `${process.env.REACT_APP_PAYABLE_URL}fixedAsset/submapping?id=${FixedAssetID}`,
    data,
    { headers }
  );
};

export const fixedAssetListing = async (FixedAssetID, { page, pageSize, filters = [] }) => {
  return await axios.post(
    `${process.env.REACT_APP_PAYABLE_URL}fixedAsset/getFixedAssetListing?fixedAssetID=${FixedAssetID}&page=${page}&pageSize=${pageSize}`,
    { filters }, 
    { headers: headers }
  );
};


export const reorderSubgroups = async (data) => {
    return await axios.patch(`${process.env.REACT_APP_FSCP_URL}bookClosureTB/reOrderSubGroup`, data, { headers })
}

//Purchase Submapping

export const getCurrencySubmapping = async (purchaseId) => {
  return axios.get(` ${process.env.REACT_APP_PAYABLE_URL}purchase/submapping?id=${purchaseId}`);
};

export const updateCurrencySubmapping = async (purchaseId, data) => {
  return axios.patch(` ${process.env.REACT_APP_PAYABLE_URL}purchase/submapping/${purchaseId}`, data);
};